import styled from 'styled-components';

import { Flexer } from '@ontruck/orc';
import Calendar from 'components/Calendar';

const StyledDateWrapper = styled.div`
  position: relative;
  width: fit-content;
`;

const StyledDatePlaceholder = styled(Flexer.Parent).attrs(() => ({
  alignItems: 'center',
  p: 'S',
}))`
  background: #fff;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  border-radius: ${(props) => props.theme.base.gridSizes.XS};
  border: 1px solid var(--tertiary);
`;

const StyledDateCloseButton = styled(Flexer.Child)`
  position: absolute;
  top: -1px;
  right: ${(props) => props.theme.base.gridSizes.XS};
  transform: translateY(50%);
  width: ${(props) => props.theme.base.gridSizes.S};
  height: ${(props) => props.theme.base.gridSizes.S};
`;

const StyledDateCalendar = styled(Calendar)`
  .DayPicker-Day {
    height: 4.8rem;
    width: 4.8rem;
  }
  .DayPicker-Day--dayWithJourneys {
    position: relative;
    border: 1px solid var(--grey200);
    .DayPicker-Day-tag {
      position: absolute;
      top: 0;
      right: 0;
      background-color: var(--primary500);
      color: #fff;
      padding: 0 0.2rem;
      min-width: 1.6rem;
      font-size: 1rem;
    }
  }
`;

export { StyledDateWrapper, StyledDatePlaceholder, StyledDateCloseButton, StyledDateCalendar };
